<div class="video_wrap">
    <youtube-player [videoId]="youtubeId" #youtube></youtube-player>
    <div class="placeholder" [class.close-placeholder]="closePlaceholder" (click)="playVideo()">
        <!-- <img class="placeholder_image" alt="Placeholder image" [src]="getYoutubeThumbnail()"> -->
    </div>
</div>
<div class="title_n_duration" *ngIf="isMetadataVisible">
    <div class="title">{{getYoutubeTitle()}}</div>
    <div class="duration">{{getDuration()}}</div>
</div>